$(function () {
	$(".staff-item").each(function () {
		const $this = $(this);
		const $button = $this.find(".staff-item-button");
		const $overlay = $this.find(".staff-item-caption-overlay");

		$button.on("click", function () {
			$button.toggleClass("active");
			$overlay.toggleClass("show");
		});
	});
});
